import { useState } from "react";

import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import { STRINGS } from "../utils/strings";

export default function useModalHandler() {
  const [mode, setMode] = useState(null);
  const [modalSize, setModalSize] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [additionalDetails, setAdditionalDetails] = useState({});

  const handleFailure = () => {
    setShowFailureModal(false);
    setAdditionalDetails((prev) => {
      const { error, handleFailure, ...rest } = prev;
      return rest;
    });
  };

  const openFailureModal = (error) => {
    setAdditionalDetails((prev) => ({
      ...prev,
      error: ApiRequestErrorHandler(error),
      handleFailure: () => handleFailure(),
    }));
    setShowFailureModal(true);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const openSuccessModal = () => {
    setShowFailureModal(false);
    setAdditionalDetails({
      handleSuccess: handleSuccess,
    });
    setMode(STRINGS.MODAL_MODE.SUCCESS);
    setModalSize(STRINGS.MODAL_SIZE.X_SMALL);
    handleOpenModal();
  };

  const handleSuccess = () => {
    handleCloseModal();
  };

  return {
    mode,
    modalSize,
    openModal,
    showFailureModal,
    additionalDetails,
    handleCloseModal,
    handleFailure,
    openSuccessModal,
    openFailureModal,
  };
}
